import * as React from 'react'

function SvgSk(props) {
	return (
		<svg viewBox="0 0 9 6" width="1em" height="1em" {...props}>
			<path fill="#ee1c25" d="M0 0h9v6H0z" />
			<path fill="#0b4ea2" d="M0 0h9v4H0z" />
			<path fill="#fff" d="M0 0h9v2H0z" />
			<path
				fill="#fff"
				d="M3.163 4.635c-.538-.259-1.308-.773-1.308-1.79s.05-1.48.05-1.48H4.42s.049.463.049 1.48-.77 1.53-1.307 1.79z"
			/>
			<path
				fill="#ee1c25"
				d="M3.163 4.5c-.494-.238-1.2-.71-1.2-1.643S2.008 1.5 2.008 1.5h2.309s.045.424.045 1.357c0 .934-.706 1.405-1.2 1.643z"
			/>
			<path
				fill="#fff"
				d="M3.268 2.613c.134.002.394.007.626-.07 0 0-.006.083-.006.18 0 .096.006.18.006.18-.212-.072-.475-.074-.626-.072v.516h-.211V2.83c-.15-.002-.413 0-.626.071 0 0 .006-.083.006-.18 0-.096-.006-.18-.006-.18.232.078.492.073.626.07V2.29a1.481 1.481 0 00-.496.071s.007-.083.007-.18c0-.096-.007-.18-.007-.18.199.067.374.073.496.072-.007-.205-.066-.464-.066-.464s.122.01.172.01c.049 0 .172-.01.172-.01s-.06.259-.066.464A1.48 1.48 0 003.764 2s-.006.083-.006.18c0 .096.006.18.006.18a1.481 1.481 0 00-.496-.072v.324z"
			/>
			<path
				fill="#0b4ea2"
				d="M3.163 3.29c-.249 0-.382.346-.382.346s-.074-.164-.277-.164c-.137 0-.238.122-.302.235.25.397.648.642.96.793.313-.15.712-.396.961-.793-.064-.113-.165-.235-.302-.235-.203 0-.277.164-.277.164s-.133-.345-.382-.345z"
			/>
		</svg>
	)
}

export default SvgSk
